import { parseUnits } from 'ethers'
import { useReadContract } from 'wagmi'

import { useTokenxGGPContract } from './contracts/tokenggAVAX'

const useExchangeRate = () => {
  const { abi: xGGPInterface, address: xGGPAddress } = useTokenxGGPContract()

  const resp = useReadContract({
    address: xGGPAddress,
    abi: xGGPInterface,
    functionName: 'previewDeposit',
    args: [parseUnits('1.0')],
  })

  return resp
}

export default useExchangeRate
